document.addEventListener("DOMContentLoaded", function(event) {
    $(document).ready(function(){

        $('#heroVideoOverlay').click(function(e){
            e.preventDefault();
        
            if($('#rebuy-cart').hasClass('is-visible')) {
              var SmartCart = window.Rebuy.SmartCart;
              Rebuy.SmartCart.hide()
            } else {
                window.location.href='/collections/shop-all'
            }
          })

        if($(window).width() >= 750) {
            
            $('.logosSlider').owlCarousel({
                loop:true,
                margin: 60,
                items:4,
                nav: false,
                dots: true
            });
    
            $('.reviewsSlider').owlCarousel({
                loop:true,
                margin: 20,
                items:3.3,
                nav: true,
                navText: ["<img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_left_6x.png?v=152687409223188851801664355074' class='nonFocus' /> <img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_right_6x.png?v=75214090462226748251664355072' class='aFocus' /> ",
                          "<img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_left_6x.png?v=152687409223188851801664355074' class='nonFocus' /> <img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_right_6x.png?v=75214090462226748251664355072' class='aFocus' />"],
                dots: false,
                stagePadding: 20
            });

        } else {
            $('.logosSlider').owlCarousel({
                loop:true,
                items:1,
                nav: false,
                dots: true
            });
    
            $('.reviewsSlider').owlCarousel({
                loop:true,
                margin: 16,
                items:1.1,
                nav: true,
                navText: ["<img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_left_6x.png?v=152687409223188851801664355074' class='nonFocus' /> <img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_right_6x.png?v=75214090462226748251664355072' class='aFocus' /> ",
                          "<img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_left_6x.png?v=152687409223188851801664355074' class='nonFocus' /> <img src='//cdn.shopify.com/s/files/1/0321/3328/3971/t/235/assets/slider_ico_right_6x.png?v=75214090462226748251664355072' class='aFocus' />"],
                dots: false,
                stagePadding: 10
            });

            $('.banner .banner__content .banner__box .banner__buttons a').text('Shop Now');
            
            $('.section-review .collection .collection__title a').insertAfter($('.reviewsSlider'))

            
        }
        
    })

})